module.exports = __webpack_public_path__ + "img/pain-spot-6.d89c8fc4.svg";